import { JSX } from "react";
import "./Pagination.css";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const maxVisible = 5;
  const pages: JSX.Element[] = [];

  let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
  let endPage = startPage + maxVisible - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxVisible + 1);
  }

  if (startPage > 1) {
    pages.push(
      <button key={1} onClick={() => onPageChange(1)} className={currentPage === 1 ? "active" : ""}>
        1
      </button>
    );
    if (startPage > 2) {
      pages.push(<span key="start-ellipsis">…</span>);
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <button
        key={i}
        className={currentPage === i ? "active" : ""}
        onClick={() => onPageChange(i)}
      >
        {i}
      </button>
    );
  }

  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      pages.push(<span key="end-ellipsis">…</span>);
    }
    pages.push(
      <button
        key={totalPages}
        onClick={() => onPageChange(totalPages)}
        className={currentPage === totalPages ? "active" : ""}
      >
        {totalPages}
      </button>
    );
  }

  return (
    <div className="pagination-controls inside-table">
      <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
        ‹
      </button>
      {pages}
      <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
        ›
      </button>
    </div>
  );
};

export default Pagination;
